import useSWR from 'swr';

import { Roles } from '../user';

import { getSubUnits } from './slice';

type PropsType = {
  employeeId: number;
};

type OutputType = {
  deputyResponsibilityUnits: number[];
  alternateManagerResponsibilityUnits: number[];
  managerResponsibilityUnits: number[];
  hrResponsibilityUnits: number[];
};

export const getOrgUnitsEmpHasResponsibilityOver = async (
  employeeId: number,
): Promise<OutputType> => {
  const [
    deputyResponsibilityUnits,
    alternateManagerResponsibilityUnits,
    managerResponsibilityUnits,
    hrResponsibilityUnits,
  ] = await Promise.all([
    getSubUnits(employeeId, Roles.DEPUTY_MANAGER),
    getSubUnits(employeeId, Roles.ALT_MANAGER),
    getSubUnits(employeeId),
    getSubUnits(employeeId, 'HR'),
  ]);
  return {
    deputyResponsibilityUnits,
    alternateManagerResponsibilityUnits,
    managerResponsibilityUnits,
    hrResponsibilityUnits,
  };
};

export const useOrgUnitsEmpHasResponsibilityOver = (props: PropsType) => {
  const { employeeId } = props;

  const { data, isLoading, error } = useSWR(
    ['orgUnitsEmpHasResponsibilityOver', employeeId],
    () => getOrgUnitsEmpHasResponsibilityOver(employeeId),
  );

  return {
    data: data || {
      deputyResponsibilityUnits: [],
      alternateManagerResponsibilityUnits: [],
      managerResponsibilityUnits: [],
      hrResponsibilityUnits: [],
    },
    isLoading,
    error,
  };
};
